import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonIconComponent } from '../buttons/button-icon/button-icon.component';
import { ErrorAnimationComponent } from '../animations/animation-player/error-animation/error-animation.component';
import { MatButtonModule } from '@angular/material/button';
import { ModalMessageData } from '@core/models/modal-message-data.interface';
import { SuccessAnimationComponent } from '../animations/animation-player/success-animation/success-animation.component';
import { NotificationVariant } from '@core/enums/notifications/notification-variant.enum';

@Component({
  selector: 'cgw-modal-message',
  standalone: true,
  imports: [ErrorAnimationComponent, SuccessAnimationComponent, MatButtonModule],
  templateUrl: './modal-message.component.html',
  styleUrl: './modal-message.component.scss',
})
export class ModalMessageComponent {
  public notificationType = NotificationVariant;
  public readonly data = inject<ModalMessageData>(MAT_DIALOG_DATA);
  private readonly _dialogRef = inject(MatDialogRef<ModalMessageComponent>);
  public continue(): void {
    this._dialogRef.close(true);
  }
}
